export const translations = {
  id: {
    nav: {
      about: "Tentang",
      services: "Layanan",
      work: "Portofolio",
      team: "Tim",
      contact: "Hubungi Kami",
      tagline: "Creative Event Organizer — Indonesia",
    },
    hero: {
      kicker: "Creative Event Organizer — Indonesia",
      lines: ["Menciptakan", "Pengalaman", "Melampaui", "Ekspektasi."],
      intro:
        "Creative event organizer yang menghadirkan pengalaman event menyeluruh — memadukan kreativitas dengan manajemen event profesional dan eksekusi tanpa cela untuk brand, korporasi, dan institusi pemerintah.",
      ctaProposal: "Minta Proposal",
      ctaDiscuss: "Diskusi Event Anda",
      ctaPortfolio: "Lihat Portofolio",
      badges: ["50+ Event Terlaksana", "Pemerintah, Korporat & FMCG", "Dipercaya di Seluruh Indonesia"],
      scroll: "Gulir untuk menjelajah",
      tagline: "More Than Just Events",
      visualAlt: "Tim produksi Payung Oren Creative mengendalikan show control di sebuah event",
    },
    chapters: {
      about: "Tentang Kami",
      why: "Mengapa Kami",
      services: "Layanan",
      leadership: "Kepemimpinan",
      team: "Tim Kami",
      work: "Portofolio Pilihan",
      reviews: "Ulasan Klien",
      clients: "Klien",
      impact: "Dampak Kami",
      coverage: "Jangkauan",
      contact: "Kontak",
    },
    about: {
      headingA: "Kami berawal dari tim kecil — dan membangun segalanya",
      headingB: "dari nol.",
      p1: "Payung Oren Creative adalah creative event organizer yang berpegang pada satu keyakinan: setiap event layak mendapatkan imajinasi sekaligus disiplin. Kami memadukan pemikiran kreatif dengan manajemen event profesional — merencanakan, memproduksi, dan mengeksekusi pengalaman yang berjalan sempurna dari konsep pertama hingga tepuk tangan terakhir.",
      p2: "Yang membedakan kami adalah kepemilikan. Satu tim membawa event Anda dari awal hingga akhir — dilaksanakan dengan kepedulian, detail, dan komitmen.",
      photoAlt: "Tim Payung Oren Creative bertugas di sebuah event",
      entities: "Beroperasi di bawah tiga perusahaan terdaftar di Indonesia",
      specializing: "Spesialisasi kami",
      specialties: [
        "Event Pemerintah",
        "Event Korporat",
        "Brand Activation",
        "Product Launch",
        "Event Komunitas",
        "Gathering",
        "Roadshow",
        "Produksi Event Kreatif",
      ],
    },
    why: {
      heading: "Kekuatan, bukan slogan.",
      cards: [
        { title: "Konsep Kreatif & Relevan", text: "Ide yang disesuaikan dengan audiens, tujuan, dan karakter brand Anda." },
        { title: "Eksekusi Berorientasi Detail", text: "Setiap elemen disempurnakan — dari rundown hingga isyarat cahaya terakhir." },
        { title: "Koordinasi Adaptif & Cepat", text: "Tim responsif yang bergerak mengikuti kecepatan event Anda." },
        { title: "Wawasan Youth & Lifestyle", text: "Pemahaman kuat tentang budaya anak muda dan tren gaya hidup." },
        { title: "Manajemen Event Menyeluruh", text: "Konsep, eksekusi, dan pelaporan — satu tim yang bertanggung jawab." },
        { title: "Produksi 950 Pax", text: "Event pemerintah terbesar kami hingga saat ini — RAPIM TNI AD TA 2026." },
      ],
    },
    services: {
      headingA: "Keahlian utama",
      headingB: "kami.",
      items: {
        "event-management": {
          name: "Manajemen Event",
          tag: "Menyeluruh, dari konsep hingga eksekusi",
          desc: "Manajemen event menyeluruh dalam satu tim yang bertanggung jawab — dari pengembangan konsep dan arahan kreatif hingga produksi, show management, dan pelaporan pasca-event. Kami memegang setiap lapisan, agar event Anda bergerak ke satu arah: maju.",
          delivers: ["Konsep & pengembangan kreatif", "Rundown & show management", "Produksi panggung, tata suara & cahaya", "Koordinasi venue & vendor", "Tim eksekusi di lapangan", "Laporan pasca-event"],
          imgCaption: "iLink Mini Exhibition — produksi penuh oleh Payung Oren Creative",
        },
        "corporate-event": {
          name: "Event Korporat",
          tag: "Rapat, konferensi & seremoni",
          desc: "Rapat, konferensi, dan seremoni korporat yang dieksekusi dengan presisi setara protokol — dipercaya untuk produksi dari sesi boardroom 90 pax hingga konferensi kepemimpinan nasional 916 pax.",
          delivers: ["Koordinasi hotel & venue", "Panggung, tata suara & cahaya", "Pengaturan tempat duduk & ruang", "Registrasi & alur tamu", "Penanganan protokol VVIP", "Desain & dokumentasi"],
          imgCaption: "Produksi rapat korporat untuk TNI AD — venue penuh & guest experience",
        },
        "brand-activation": {
          name: "Brand Activation",
          tag: "Sampling, roadshow & consumer engagement",
          desc: "Aktivasi yang menempatkan produk Anda di tangan yang tepat dan brand Anda dalam percakapan yang tepat — direncanakan, diperkuat tim, dan diukur dari awal hingga akhir.",
          delivers: ["Product sampling", "Aktivasi roadshow", "Penempatan SPG/SPB", "Consumer engagement", "Dukungan product launch", "Pelaporan & pemantauan KPI"],
        },
        "event-gathering": {
          name: "Event Gathering",
          tag: "Gathering perusahaan & privat",
          desc: "Gathering yang benar-benar dikenang — company outing, program tim, dan gala dinner yang dirancang untuk membangun koneksi, bukan sekadar logistik.",
          delivers: ["Pengaturan transportasi", "Koordinasi hotel", "Rundown, manpower & aktivitas", "Produksi gala dinner", "Gimmick & games kreatif", "Desain & dokumentasi"],
          imgCaption: "Evonik Synergy in Paradise — gathering Bali, 90 pax",
        },
        "community-event": {
          name: "Event Komunitas",
          tag: "Program publik & festival",
          desc: "Program publik dan festival komunitas yang dirancang untuk partisipasi — dari konsep dan programming hingga alur kerumunan dan eksekusi di lapangan.",
          delivers: ["Konsep & programming", "Koordinasi pemangku kepentingan & perizinan", "Panggung & produksi", "Alur kerumunan & keamanan", "Community engagement", "Dokumentasi"],
        },
        "campus-event": {
          name: "Event Kampus",
          tag: "Program universitas & mahasiswa",
          desc: "Program kampus yang berbicara dalam bahasa mahasiswa — seminar, workshop, dan aktivasi kampus dengan engagement anak muda yang tulus.",
          delivers: ["Liaison kampus & perizinan", "Seminar & workshop", "Panggung & produksi", "Program engagement mahasiswa", "Koordinasi sponsorship", "Dokumentasi"],
        },
        "launching-event": {
          name: "Launching Event",
          tag: "Peluncuran produk & brand",
          desc: "Momen peluncuran yang direkayasa untuk dampak — sebuah narasi, sebuah reveal, dan audiens yang mengingat kesan pertama produk Anda.",
          delivers: ["Konsep & narasi peluncuran", "Produksi panggung & reveal", "Manajemen media & tamu", "Desain brand experience", "Pengambilan konten", "Laporan pasca-peluncuran"],
        },
      },
    },
    servicesPage: {
      back: "Semua Layanan",
      prefix: "Layanan",
      deliverLabel: "Yang kami kerjakan",
      ctaTitle: "Butuh proposal atau project deck?",
      ctaSub: "Ceritakan tentang event Anda — kami biasanya membalas dalam satu hari kerja.",
      ctaProposal: "Minta Proposal",
      ctaMeeting: "Jadwalkan Pertemuan",
      ctaWhatsApp: "Diskusi via WhatsApp",
      next: "Layanan berikutnya",
      photoComing: "foto segera hadir",
      waMessage: "Halo Payung Oren Creative, kami ingin meminta proposal atau project deck untuk",
      proposalSubject: "Permintaan proposal",
      meetingSubject: "Permintaan pertemuan",
    },
    impact: {
      subline: "Di seluruh program korporat, pemerintah, dan brand di Indonesia — dari gathering intim 90 pax hingga konferensi kepemimpinan nasional 916 pax.",
      stats: [
        { label: "Event Terlaksana" },
        { label: "Peserta Dikelola" },
        { text: "Gov & Corp", label: "Pengalaman Pemerintah & Korporat" },
        { text: "Lintas Industri", label: "Proyek di Berbagai Industri" },
      ],
      formatsLabel: "Format yang kami kerjakan",
      categories: ["Event Korporat", "Event Pemerintah", "Brand Activation", "Konferensi", "Pameran", "Product Launch", "Gathering", "Produksi Teknis Event", "Kampanye FMCG"],
    },
    coverage: {
      headingA: "Berkantor di Bekasi Utara.",
      headingB: "Melayani di mana pun.",
      text: "Kantor pusat kami berada di Bekasi Utara — beberapa menit dari Jakarta, dibangun untuk Indonesia. Kami menghadirkan event di seluruh Jabodetabek dan Jawa Barat, dan bepergian ke seluruh Indonesia kapan pun proyek membutuhkan.",
      headOffice: "Kantor pusat — Bekasi Utara, Indonesia",
      nationwide: "+ Proyek di seluruh Indonesia",
      areas: ["Jakarta", "Bogor", "Depok", "Tangerang", "Bekasi", "Jawa Barat"],
    },
    projects: {
      headingA: "Proyek",
      headingB: "unggulan.",
      recentHeading: "Proyek Terbaru",
      recentTag: "Produksi yang telah selesai",
      galleryHeading: "Galeri",
      galleryTag: "Dokumentasi event resmi",
      featured: [
        {
          title: "Rapat Pimpinan TNI AD TA 2026",
          client: "Tentara Nasional Indonesia Angkatan Darat",
          meta: "Pemerintah · Konferensi Kepemimpinan",
          stat: "950 Peserta",
          img: "/assets/proj-rapim.jpg",
          span: "md:col-span-7",
          ratio: "aspect-[4/3]",
        },
        {
          title: "Synergy in Paradise",
          client: "PT Evonik Indonesia",
          meta: "Gathering Korporat · Bali",
          stat: "90 Peserta",
          imgs: ["/assets/proj-evonik.jpg", "/assets/gal-evonik-fun.jpg", "/assets/gal-evonik-kecak.jpg", "/assets/gal-evonik-gala.jpg"],
          span: "md:col-span-5",
          ratio: "aspect-[4/3]",
        },
        {
          title: "iLink Mini Exhibition",
          client: "iLink Logistics",
          meta: "Pameran · Kemitraan Produksi",
          scope: ["Produksi Panggung", "Sistem LED & Visual", "Produksi Teknis", "Dukungan Eksekusi Event"],
          imgs: ["/assets/gal-ilink-uk.jpg", "/assets/gal-ilink-boxes.jpg", "/assets/gal-ilink-usa.jpg"],
          span: "md:col-span-12",
          ratio: "aspect-[4/3] md:aspect-[21/8]",
        },
      ],
      index: [
        { title: "RAPIM TNI AD TA 2026", type: "Pemerintah · Konferensi Kepemimpinan", pax: "950 Peserta", img: "/assets/proj-rapim.jpg" },
        { title: "Sinkronisasi Data RKA Bidang Logistik TA 2027", type: "Pemerintah", pax: "229 Peserta", img: "/assets/team-stage.jpg" },
        { title: "Evonik Indonesia — Synergy in Paradise", type: "Gathering Korporat · Bali", pax: "90 Peserta", img: "/assets/proj-evonik.jpg" },
        { title: "iLink Logistics — Mini Exhibition", type: "Pameran · Produksi", scope: ["Produksi Panggung", "Sistem LED & Visual", "Produksi Teknis"], img: "/assets/proj-ilink.jpg" },
        { title: "Rekonsiliasi Terpusat — Penyusunan Laporan Keuangan TNI AD TA 2025", type: "Pemerintah", pax: "380 Peserta" },
        { title: "Rakernis Bid. Rengar TNI AD TA 2026", type: "Pemerintah", pax: "201 Peserta" },
        { title: "Rakernis PNBP BLU TNI AD TA 2026", type: "Pemerintah", pax: "201 Peserta" },
        { title: "RAKERNISTER TK TNI AD TA 2026", type: "Pemerintah", pax: "162 Peserta" },
        { title: "Rapat Kerja Teknis Bidang Logistik TNI AD TA 2026", type: "Pemerintah", pax: "250 Peserta" },
        { title: "Sinkronisasi Data SISFOREN Satker Jajaran TNI AD", type: "Pemerintah", pax: "539 Peserta" },
        { title: "Sinkronisasi & Percepatan Belanja Modal Rumkit TNI AD", type: "Pemerintah", pax: "214 Peserta" },
        { title: "Pelatihan & Uji Kompetensi PPK di Lingkungan TNI AD Terpusat TA 2026", type: "Pemerintah", pax: "275 Peserta" },
        { title: "Evaluasi Reformasi Birokrasi & Pembangunan Zona Integritas TA 2026", type: "Pemerintah", pax: "218 Peserta" },
        { title: "Rapat Evaluasi Satker PNBP Yankes & BLU Jajaran TNI AD", type: "Pemerintah", pax: "172 Peserta" },
        { title: "Pelatihan Teknis Operator Casemix RS TNI AD TA 2026", type: "Pemerintah", pax: "125 Peserta" },
      ],
      gallery: [
        { img: "/assets/gal-rapim-podium.jpg", alt: "Momen keynote di RAPIM TNI AD TA 2026" },
        { img: "/assets/gal-evonik-sign.jpg", alt: "Tim Evonik di landmark Bali saat Synergy in Paradise" },
        { img: "/assets/proj-rka-indikatif.jpg", alt: "Input Data RKA Pagu Indikatif TA 2025" },
        { img: "/assets/gal-rapim-venue.jpg", alt: "Persiapan VVIP di RAPIM TNI AD TA 2026" },
        { img: "/assets/gal-evonik-beach.jpg", alt: "Program pantai di Evonik Synergy in Paradise, Bali" },
        { img: "/assets/proj-bimtek.jpg", alt: "Panggung utama Bimtek Sisforen TNI AD 2024" },
        { img: "/assets/gal-rapim-mc.jpg", alt: "Momen panggung di RAPIM TNI AD TA 2026" },
        { img: "/assets/gal-evonik-night.jpg", alt: "Perayaan malam di gathering Evonik Bali" },
        { img: "/assets/proj-ilink.jpg", alt: "Gambaran booth iLink Mini Exhibition" },
        { img: "/assets/proj-rka-anggaran.jpg", alt: "Input Data RKA Pagu Anggaran TNI AD TA 2025" },
        { img: "/assets/proj-evaluasi.jpg", alt: "Rapat Evaluasi Sistem Informasi TNI AD TA 2024" },
      ],
    },
    leadership: {
      headingA: "Orang-orang di balik",
      headingB: "payung.",
      notable: "Pengalaman utama — ",
      list: [
        {
          name: "Clara Chatrina",
          role: "Pendiri & Chief Executive Officer",
          img: "/assets/leader-clara.png",
          intro: "Pendiri dan chief executive dengan rekam jejak di program korporat dan pemerintah — memimpin strategi, koordinasi pemangku kepentingan, dan eksekusi untuk institusi nasional dan brand multinasional.",
          points: [
            "Berpengalaman dalam event korporat & proyek pemerintah",
            "Memimpin eksekusi event korporat, institusional, dan sektor publik",
            "Keahlian kuat dalam manajemen proyek dan koordinasi pemangku kepentingan",
          ],
          clients: "Pertamina Patra Niaga · TNI AD · PT Evonik Indonesia",
        },
        {
          name: "Yasmine Elinel Santoso",
          role: "Chief Operating Officer",
          img: "/assets/leader-yasmine.png",
          intro: "Chief operating officer yang berspesialisasi dalam brand activation dan consumer engagement — memimpin roadshow FMCG dan kampanye berbasis penjualan dari perencanaan hingga pelaporan.",
          points: [
            "Berpengalaman dalam brand activation & consumer engagement",
            "Spesialisasi aktivasi FMCG, roadshow, dan kampanye berbasis penjualan",
            "Keahlian eksekusi proyek menyeluruh, dari perencanaan hingga pelaporan",
          ],
          clients: "Kapal Api · Good Day · Gudang Garam",
        },
      ],
    },
    team: {
      headingA: "Di balik setiap",
      headingB: "event hebat.",
      intro: "Event hebat tidak pernah lahir dari dua orang saja. Di balik setiap produksi berdiri kru yang solid — produser, koordinator, tim panggung dan show — yang memperlakukan setiap event seperti milik sendiri. Dari survei lokasi pertama hingga tepuk tangan terakhir, kami hadir bersama.",
      captions: [
        "Show control — tepat waktu, setiap isyarat",
        "Koordinasi lapangan",
        "Tim guest experience",
        "Produksi korporat skala penuh",
        "Desain panggung, LED & pencahayaan",
        "Kru kami, setelah pertunjukan sukses",
      ],
    },
    reviews: {
      headingA: "Kata",
      headingB: "klien kami.",
      leaveButton: "Tulis Ulasan",
      verifiedBadge: "Ulasan klien terverifikasi",
      summarySuffix: "ulasan terverifikasi",
      emptyState: "Belum ada ulasan — jadilah yang pertama berbagi pengalaman Anda.",
      modal: {
        title: "Tulis Ulasan",
        note: "Ulasan tampil langsung dan dapat dimoderasi oleh admin",
        name: "Nama Lengkap",
        company: "Perusahaan",
        position: "Jabatan",
        rating: "Rating Anda",
        reviewPh: "Ceritakan pengalaman Anda bekerja dengan kami",
        submit: "Kirim Ulasan",
        sending: "Mengirim…",
        toastRating: "Pilih rating bintang terlebih dahulu",
        toastSuccess: "Terima kasih — ulasan Anda telah tampil.",
        toastError: "Ulasan gagal dikirim. Silakan coba lagi.",
      },
    },
    clients: {
      headingA: "Dipercaya",
      headingB: "nama-nama hebat.",
      caption: "Klien & mitra resmi — dari institusi nasional hingga brand multinasional",
    },
    contact: {
      headingA: "Lebih dari",
      headingB: "sekadar event.",
      sub: "Kami menciptakan momen, pengalaman, dan koneksi yang dibawa orang jauh setelah acara usai. Mari berkolaborasi.",
      nameLabel: "Nama",
      emailLabel: "Email",
      messageLabel: "Pesan",
      namePh: "Nama Anda",
      emailPh: "anda@perusahaan.com",
      messagePh: "Ceritakan tentang event Anda",
      submit: "Kirim Pesan",
      note: "Membuka aplikasi email Anda — tidak ada data yang disimpan",
      corporateLabel: "WhatsApp — Korporat",
      activationLabel: "WhatsApp — Aktivasi",
      mapCaption: "Berkantor di Bekasi Utara — menghadirkan event di seluruh Jabodetabek dan lebih jauh",
      areas: "Jabodetabek · Jawa Barat · Seluruh Indonesia · Luar Jawa sesuai kebutuhan",
      emailSubject: "Permintaan baru dari situs web",
      toast: "Membuka aplikasi email Anda…",
    },
    footer: {
      copyright: "© 2026 Payung Oren Creative — Creative Event Organizer, Indonesia",
      entities: "Beroperasi di bawah tiga badan usaha terdaftar di Indonesia",
      backToTop: "Kembali ke atas",
    },
    divider: {
      caption: "Setiap tamu, setiap detail, kami tangani secara personal",
    },
  },

  en: {
    nav: {
      about: "About",
      services: "Services",
      work: "Work",
      team: "Team",
      contact: "Contact Us",
      tagline: "Creative Event Organizer — Indonesia",
    },
    hero: {
      kicker: "Creative Event Organizer — Indonesia",
      lines: ["Creating", "Experiences", "Beyond", "Expectations."],
      intro:
        "A creative event organizer delivering end-to-end event experiences — combining creativity with professional event management and flawless execution for brands, corporations, and government institutions.",
      ctaProposal: "Request Proposal",
      ctaDiscuss: "Discuss Your Event",
      ctaPortfolio: "View Portfolio",
      badges: ["50+ Events Delivered", "Government, Corporate & FMCG", "Trusted Across Indonesia"],
      scroll: "Scroll to explore",
      tagline: "More Than Just Events",
      visualAlt: "Payung Oren Creative production team running show control at a live event",
    },
    chapters: {
      about: "About Us",
      why: "Why Choose Us",
      services: "Services",
      leadership: "Leadership",
      team: "The Team",
      work: "Selected Work",
      reviews: "Client Reviews",
      clients: "Clients",
      impact: "Company Impact",
      coverage: "Coverage",
      contact: "Contact",
    },
    about: {
      headingA: "We started as a small team — and built everything",
      headingB: "from the ground up.",
      p1: "Payung Oren Creative is a creative event organizer built on one belief: every event deserves both imagination and discipline. We combine creative thinking with professional event management — planning, producing, and executing experiences that run flawlessly from first concept to final applause.",
      p2: "What makes us different is ownership. One team carries your event end to end — delivered with care, detail, and commitment.",
      photoAlt: "The Payung Oren Creative team on-site at an event",
      entities: "Operating under three registered Indonesian companies",
      specializing: "Specializing in",
      specialties: [
        "Government Events",
        "Corporate Events",
        "Brand Activations",
        "Product Launches",
        "Community Events",
        "Gatherings",
        "Roadshows",
        "Creative Event Production",
      ],
    },
    why: {
      heading: "Strengths, not slogans.",
      cards: [
        { title: "Creative & Relevant Concepts", text: "Ideas tailored to your audience, objectives, and brand character." },
        { title: "Detail-Oriented Execution", text: "Every element refined — from rundown to the final light cue." },
        { title: "Adaptive & Fast Coordination", text: "Responsive teams that move at the speed of your event." },
        { title: "Youth & Lifestyle Insight", text: "A strong understanding of youth culture and lifestyle trends." },
        { title: "End-to-End Event Management", text: "Concept, execution, and reporting — one accountable team." },
        { title: "950-Pax Production", text: "Our largest government event to date — Rapat Pimpinan TNI AD TA 2026." },
      ],
    },
    services: {
      headingA: "What we do",
      headingB: "best.",
      items: {
        "event-management": {
          name: "Event Management",
          tag: "End-to-end, from concept to execution",
          desc: "Complete event management under one accountable team — from concept development and creative direction to production, show management, and post-event reporting. We own every layer, so your event moves in one direction: forward.",
          delivers: ["Concept & creative development", "Rundown & show management", "Stage, sound & lighting production", "Venue & vendor coordination", "On-site execution team", "Post-event reporting"],
          imgCaption: "iLink Mini Exhibition — full production by Payung Oren Creative",
        },
        "corporate-event": {
          name: "Corporate Event",
          tag: "Meetings, conferences & ceremonies",
          desc: "Corporate meetings, conferences, and ceremonies delivered with protocol-level precision — trusted for productions from 90-pax boardroom sessions to a 916-pax national leadership conference.",
          delivers: ["Hotel & venue coordination", "Stage, sound & lighting", "Seating & room arrangement", "Registration & guest flow", "VVIP protocol handling", "Design & documentation"],
          imgCaption: "Corporate meeting productions for TNI AD — full venue and guest experience",
        },
        "brand-activation": {
          name: "Brand Activation",
          tag: "Sampling, roadshows & consumer engagement",
          desc: "Activations that put your product in the right hands and your brand in the right conversations — planned, staffed, and measured end to end.",
          delivers: ["Product sampling", "Roadshow activation", "SPG/SPB deployment", "Consumer engagement", "Product launch support", "Reporting & KPI monitoring"],
        },
        "event-gathering": {
          name: "Event Gathering",
          tag: "Company & private gatherings",
          desc: "Gatherings people actually remember — company outings, team programs, and gala dinners designed around connection, not just logistics.",
          delivers: ["Transport arrangement", "Hotel coordination", "Rundown, manpower & activities", "Gala dinner production", "Creative gimmicks & games", "Design & documentation"],
          imgCaption: "Evonik Synergy in Paradise — Bali gathering, 90 pax",
        },
        "community-event": {
          name: "Community Event",
          tag: "Public programs & festivals",
          desc: "Public programs and community festivals built for participation — from concept and programming to crowd flow and on-ground execution.",
          delivers: ["Concept & programming", "Stakeholder & permit coordination", "Stage & production", "Crowd & safety flow", "Community engagement", "Documentation"],
        },
        "campus-event": {
          name: "Campus Event",
          tag: "University & student programs",
          desc: "Campus programs that speak students' language — seminars, workshops, and campus activations with genuine youth engagement.",
          delivers: ["Campus liaison & permits", "Seminars & workshops", "Stage & production", "Student engagement program", "Sponsorship coordination", "Documentation"],
        },
        "launching-event": {
          name: "Launching Event",
          tag: "Product & brand launches",
          desc: "Launch moments engineered for impact — a narrative, a reveal, and an audience that remembers your product's first impression.",
          delivers: ["Launch concept & narrative", "Stage & reveal production", "Media & guest management", "Brand experience design", "Content capture", "Post-launch reporting"],
        },
      },
    },
    servicesPage: {
      back: "All Services",
      prefix: "Services",
      deliverLabel: "What we deliver",
      ctaTitle: "Need a proposal or project deck?",
      ctaSub: "Tell us about your event — we usually reply within one business day.",
      ctaProposal: "Request Proposal",
      ctaMeeting: "Schedule a Meeting",
      ctaWhatsApp: "Discuss on WhatsApp",
      next: "Next service",
      photoComing: "photography coming soon",
      waMessage: "Hello Payung Oren Creative, we would like to request a proposal or project deck for",
      proposalSubject: "Proposal request",
      meetingSubject: "Meeting request",
    },
    impact: {
      subline: "Across corporate, government, and brand programs throughout Indonesia — from intimate gatherings of 90 to a 916-pax national leadership conference.",
      stats: [
        { label: "Events Delivered" },
        { label: "Participants Managed" },
        { text: "Gov & Corp", label: "Government & Corporate Experience" },
        { text: "Multi-Industry", label: "Projects Across Industries" },
      ],
      formatsLabel: "Formats we deliver",
      categories: ["Corporate Events", "Government Events", "Brand Activations", "Conferences", "Exhibitions", "Product Launches", "Gatherings", "Technical Event Production", "FMCG Campaigns"],
    },
    coverage: {
      headingA: "Based in North Bekasi.",
      headingB: "Delivering everywhere.",
      text: "Our head office sits in Bekasi Utara — minutes from Jakarta, built for Indonesia. We deliver events across Jabodetabek and West Java, and travel nationwide whenever a project calls for it.",
      headOffice: "Head office — Bekasi Utara, Indonesia",
      nationwide: "+ Projects throughout Indonesia",
      areas: ["Jakarta", "Bogor", "Depok", "Tangerang", "Bekasi", "West Java"],
    },
    projects: {
      headingA: "Featured",
      headingB: "projects.",
      recentHeading: "Recent Projects",
      recentTag: "Completed productions",
      galleryHeading: "Gallery",
      galleryTag: "Official event photography",
      featured: [
        {
          title: "Rapat Pimpinan TNI AD TA 2026",
          client: "Tentara Nasional Indonesia Angkatan Darat",
          meta: "Government · Leadership Conference",
          stat: "950 Participants",
          img: "/assets/proj-rapim.jpg",
          span: "md:col-span-7",
          ratio: "aspect-[4/3]",
        },
        {
          title: "Synergy in Paradise",
          client: "PT Evonik Indonesia",
          meta: "Corporate Gathering · Bali",
          stat: "90 Participants",
          imgs: ["/assets/proj-evonik.jpg", "/assets/gal-evonik-fun.jpg", "/assets/gal-evonik-kecak.jpg", "/assets/gal-evonik-gala.jpg"],
          span: "md:col-span-5",
          ratio: "aspect-[4/3]",
        },
        {
          title: "iLink Mini Exhibition",
          client: "iLink Logistics",
          meta: "Exhibition · Production Partnership",
          scope: ["Stage Production", "LED & Visual Systems", "Technical Production", "Event Execution Support"],
          imgs: ["/assets/gal-ilink-uk.jpg", "/assets/gal-ilink-boxes.jpg", "/assets/gal-ilink-usa.jpg"],
          span: "md:col-span-12",
          ratio: "aspect-[4/3] md:aspect-[21/8]",
        },
      ],
      index: [
        { title: "RAPIM TNI AD TA 2026", type: "Government · Leadership Conference", pax: "950 Participants", img: "/assets/proj-rapim.jpg" },
        { title: "Sinkronisasi Data RKA Bidang Logistik TA 2027", type: "Government", pax: "229 Participants", img: "/assets/team-stage.jpg" },
        { title: "Evonik Indonesia — Synergy in Paradise", type: "Corporate Gathering · Bali", pax: "90 Participants", img: "/assets/proj-evonik.jpg" },
        { title: "iLink Logistics — Mini Exhibition", type: "Exhibition · Production", scope: ["Stage Production", "LED & Visual Systems", "Technical Production"], img: "/assets/proj-ilink.jpg" },
        { title: "Rekonsiliasi Terpusat — Penyusunan Laporan Keuangan TNI AD TA 2025", type: "Government", pax: "380 Participants" },
        { title: "Rakernis Bid. Rengar TNI AD TA 2026", type: "Government", pax: "201 Participants" },
        { title: "Rakernis PNBP BLU TNI AD TA 2026", type: "Government", pax: "201 Participants" },
        { title: "RAKERNISTER TK TNI AD TA 2026", type: "Government", pax: "162 Participants" },
        { title: "Rapat Kerja Teknis Bidang Logistik TNI AD TA 2026", type: "Government", pax: "250 Participants" },
        { title: "Sinkronisasi Data SISFOREN Satker Jajaran TNI AD", type: "Government", pax: "539 Participants" },
        { title: "Sinkronisasi & Percepatan Belanja Modal Rumkit TNI AD", type: "Government", pax: "214 Participants" },
        { title: "Pelatihan & Uji Kompetensi PPK di Lingkungan TNI AD Terpusat TA 2026", type: "Government", pax: "275 Participants" },
        { title: "Evaluasi Reformasi Birokrasi & Pembangunan Zona Integritas TA 2026", type: "Government", pax: "218 Participants" },
        { title: "Rapat Evaluasi Satker PNBP Yankes & BLU Jajaran TNI AD", type: "Government", pax: "172 Participants" },
        { title: "Pelatihan Teknis Operator Casemix RS TNI AD TA 2026", type: "Government", pax: "125 Participants" },
      ],
      gallery: [
        { img: "/assets/gal-rapim-podium.jpg", alt: "Keynote moment at Rapat Pimpinan TNI AD TA 2026" },
        { img: "/assets/gal-evonik-sign.jpg", alt: "Evonik team at a Bali landmark during Synergy in Paradise" },
        { img: "/assets/proj-rka-indikatif.jpg", alt: "Input Data RKA Pagu Indikatif TA 2025" },
        { img: "/assets/gal-rapim-venue.jpg", alt: "VVIP preparation at Rapat Pimpinan TNI AD TA 2026" },
        { img: "/assets/gal-evonik-beach.jpg", alt: "Beach program at Evonik Synergy in Paradise, Bali" },
        { img: "/assets/proj-bimtek.jpg", alt: "Bimtek Sisforen TNI AD 2024 main stage" },
        { img: "/assets/gal-rapim-mc.jpg", alt: "Stage moment at Rapat Pimpinan TNI AD TA 2026" },
        { img: "/assets/gal-evonik-night.jpg", alt: "Evening celebration at the Evonik Bali gathering" },
        { img: "/assets/proj-ilink.jpg", alt: "iLink Mini Exhibition booth overview" },
        { img: "/assets/proj-rka-anggaran.jpg", alt: "Input Data RKA Pagu Anggaran TNI AD TA 2025" },
        { img: "/assets/proj-evaluasi.jpg", alt: "Rapat Evaluasi Sistem Informasi TNI AD TA 2024" },
      ],
    },
    leadership: {
      headingA: "The people behind",
      headingB: "the umbrella.",
      notable: "Notable experience — ",
      list: [
        {
          name: "Clara Chatrina",
          role: "Founder & Chief Executive Officer",
          img: "/assets/leader-clara.png",
          intro: "Founder and chief executive with a track record across corporate and government programs — leading strategy, stakeholder coordination, and execution for national institutions and multinational brands.",
          points: [
            "Experienced in corporate events & government projects",
            "Led execution for corporate, institutional, and public sector events",
            "Strong expertise in project management and stakeholder coordination",
          ],
          clients: "Pertamina Patra Niaga · TNI AD · PT Evonik Indonesia",
        },
        {
          name: "Yasmine Elinel Santoso",
          role: "Chief Operating Officer",
          img: "/assets/leader-yasmine.png",
          intro: "Chief operating officer specializing in brand activation and consumer engagement — leading FMCG roadshows and sales-driven campaigns from planning to reporting.",
          points: [
            "Experienced in brand activation & consumer engagement",
            "Specialized in FMCG activations, roadshows, and sales-driven campaigns",
            "Expertise in end-to-end project execution, from planning to reporting",
          ],
          clients: "Kapal Api · Good Day · Gudang Garam",
        },
      ],
    },
    team: {
      headingA: "Behind every",
      headingB: "great event.",
      intro: "Great events are never the work of two people. Behind every production stands a collaborative crew — producers, coordinators, stage and show teams — who treat every event like their own. From the first site visit to the final applause, we show up together.",
      captions: [
        "Show control — on cue, every cue",
        "Floor coordination",
        "Guest experience team",
        "Full-house corporate productions",
        "Stage, LED & lighting design",
        "The crew, after a successful show",
      ],
    },
    reviews: {
      headingA: "Words from",
      headingB: "our clients.",
      leaveButton: "Leave a Review",
      verifiedBadge: "Verified client review",
      summarySuffix: "verified reviews",
      emptyState: "No reviews yet — be the first to share your experience.",
      modal: {
        title: "Leave a Review",
        note: "Reviews appear instantly and can be moderated by the admin",
        name: "Full Name",
        company: "Company",
        position: "Position",
        rating: "Your rating",
        reviewPh: "Share your experience working with us",
        submit: "Submit Review",
        sending: "Submitting…",
        toastRating: "Please select a star rating",
        toastSuccess: "Thank you — your review is now live.",
        toastError: "Could not submit your review. Please try again.",
      },
    },
    clients: {
      headingA: "Trusted by",
      headingB: "remarkable names.",
      caption: "Official clients & partners — from national institutions to multinational brands",
    },
    contact: {
      headingA: "More than",
      headingB: "just events.",
      sub: "We create moments, experiences, and connections that people carry beyond the occasion. Let’s collaborate.",
      nameLabel: "Name",
      emailLabel: "Email",
      messageLabel: "Message",
      namePh: "Your name",
      emailPh: "you@company.com",
      messagePh: "Tell us about your event",
      submit: "Send Message",
      note: "Opens your email app — no data is stored",
      corporateLabel: "WhatsApp — Corporate",
      activationLabel: "WhatsApp — Activation",
      mapCaption: "Based in North Bekasi — delivering events across Jabodetabek and beyond",
      areas: "Jabodetabek · West Java · Indonesia-wide · Outside Java on request",
      emailSubject: "New enquiry from the website",
      toast: "Opening your email app…",
    },
    footer: {
      copyright: "© 2026 Payung Oren Creative — Creative Event Organizer, Indonesia",
      entities: "Operating under three registered Indonesian business entities",
      backToTop: "Back to top",
    },
    divider: {
      caption: "Every guest, every detail, personally handled",
    },
  },
};
